export enum VisibleModalAddressValidation {
  CORRECTED = 'CORRECTED',
  ERROR = 'ERROR',
}
